import React, { useState } from "react";
import { ChevronDown } from "lucide-react";

/** Collapsible content section — same visual language as PillarSectionHeader
 *  but tappable, with a chevron and per-section persisted open state so each
 *  tab stays short and owners only expand what they're reading. */
export const CollapseSection = ({ id, eyebrow, title, kicker, defaultOpen = false, children }) => {
  const key = `eviq.section.${id}`;
  const [open, setOpen] = useState(() => {
    try {
      const v = window.localStorage.getItem(key);
      return v == null ? defaultOpen : v === "1";
    } catch (e) {
      return defaultOpen;
    }
  });
  const toggle = () =>
    setOpen((o) => {
      try { window.localStorage.setItem(key, o ? "0" : "1"); } catch (e) {}
      return !o;
    });

  return (
    <div className="space-y-3" data-testid={`section-${id}`}>
      <button
        type="button"
        onClick={toggle}
        aria-expanded={open}
        className="w-full flex items-center gap-3 text-left pt-1 pb-1 group"
        data-testid={`section-${id}-toggle`}
      >
        <div className="min-w-0 flex-1">
          <div className="font-mono text-[9px] uppercase tracking-[0.22em] text-zinc-500">{eyebrow}</div>
          <h2 className="font-display text-xl text-white font-semibold leading-tight mt-0.5">{title}</h2>
          {open && kicker && (
            <p className="text-[12px] text-zinc-400 leading-relaxed mt-1">{kicker}</p>
          )}
        </div>
        <span
          className="shrink-0 w-7 h-7 rounded-full border border-white/10 flex items-center justify-center group-hover:border-white/25 transition-colors"
          style={{ background: "rgba(255,255,255,0.03)" }}
        >
          <ChevronDown
            className="w-4 h-4 text-zinc-400 transition-transform duration-200"
            style={{ transform: open ? "rotate(180deg)" : "none" }}
            strokeWidth={2.2}
          />
        </span>
      </button>
      {open && (
        <div className="space-y-3" data-testid={`section-${id}-content`}>
          {children}
        </div>
      )}
    </div>
  );
};
